import type { CustomerStatus } from '../../interface/Status';
import { useQuery } from '@tanstack/react-query';
import { setupPositionAPIClient } from '@/libs/axios/positionAPI';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getCustomerStatus = async (): Promise<CustomerStatus> => {
  const authToken = getCookie(authKeys.authToken);

  if (!authToken) {
    return {
      isEqi: false,
      isEqiDigital: false,
      hasPrev: false,
    };
  }

  const positionAPI = setupPositionAPIClient();
  const { data } = await positionAPI.get<CustomerStatus>(
    apiConfig.routes.customer.wallet.status
  );
  return data;
};

export const useGetCustomerStatus = () =>
  useQuery({
    queryKey: ['customer', 'status'],
    queryFn: getCustomerStatus,
    select: (data) => {
      return {
        ...data,
        accountService:
          dictionary[(String(data.isEqiDigital) as Dictionary) || 'true'],
      };
    },
  });

const dictionary = {
  true: 'Cliente Digital',
  false: 'Cliente Assessorado',
};

type Dictionary = keyof typeof dictionary;
